import { render, staticRenderFns } from "./FlowNotify.vue?vue&type=template&id=64611ca5&scoped=true"
import script from "./FlowNotify.vue?vue&type=script&lang=js"
export * from "./FlowNotify.vue?vue&type=script&lang=js"
import style0 from "./FlowNotify.vue?vue&type=style&index=0&id=64611ca5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64611ca5",
  null
  
)

export default component.exports